import { Show } from "solid-js";
import type { VoidComponent } from "solid-js";
import PhoneNumberInput from "../../../../../components/inputs/PhoneNumberInput";
import { SettingTextValue } from "../../components/SettingValue";

type EditablePhoneNumberValueProps = {
  label: string;
  phoneNumber: string;
  editing: boolean;
  editValue?: string;
  editError?: string;
  editOnChange: (phoneNumber: string) => void;
  editDisabled?: boolean;
  required?: boolean;
};

const EditablePhoneNumberValue: VoidComponent<EditablePhoneNumberValueProps> = (props) => (
  <Show when={props.editing} fallback={<SettingTextValue label={props.label}>{props.phoneNumber}</SettingTextValue>}>
    <PhoneNumberInput
      label={props.label}
      required={props.required}
      value={props.editValue}
      errorMessage={props.editError}
      onChange={(value) => props.editOnChange(value ?? "")}
      disabled={props.editDisabled}
    />
  </Show>
);

export default EditablePhoneNumberValue;
